import { createSelector } from 'reselect';

import { getProps } from 'modules/notifications/selectors';
import { getState as getParent } from 'modules/notifications/selectors/ui';

const getState = createSelector(getParent, ({ actions }) => actions ?? {});

export const isNotificationLoadingSelector = createSelector(
  getState,
  getProps,
  ({ isNotificationLoading }, id) => isNotificationLoading?.[id] ?? false
);
